import {Pipe, PipeTransform} from '@angular/core';

export enum TFilterOpera {foOperaField, foOperaIqual, foOperaInves, foOperaMenor, foOperaMaior}

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
    name: 'filterField',
    pure: false
})
export class FilterFieldPipe implements PipeTransform {

    constructor() {


    }

    transform(items: any[], field: string, value: any, opera: TFilterOpera = TFilterOpera.foOperaIqual): any[] {

        if (!items) return [];

        if (opera == TFilterOpera.foOperaField) return items.filter(item => (item[field] == item[value]));
        if (opera == TFilterOpera.foOperaIqual) return items.filter(item => (item[field] == value));
        if (opera == TFilterOpera.foOperaInves) return items.filter(item => (item[field] != value));
        if (opera == TFilterOpera.foOperaMenor) return items.filter(item => (item[field] <= value));
        if (opera == TFilterOpera.foOperaMaior) return items.filter(item => (item[field] >= value));

        return items;

    }

}



// WEBPACK FOOTER //
// ./src/pipes/filter-field/filter-field.ts